import { d as r } from "./defaultFormRuntime-BUO8dKCN.js";
import { c as n, a as u, b as d } from "./defaultFormRuntime-BUO8dKCN.js";
function m(t, o = r) {
  const e = o.themes.get(t.theme.id);
  return (e == null ? void 0 : e.tokens) ?? {};
}
export {
  n as createFormRuntime,
  r as defaultFormRuntime,
  u as defaultThemes,
  d as defaultValidators,
  m as formThemeStyle
};
